module.exports = __webpack_public_path__ + "static/media/114.8a2a785e.jpg";